module.exports = __webpack_public_path__ + "img/1482015268.41b6ad3a.jpg";